import request from '../untils/request';

export const createAlipayRemit = params => {
  return request({
    url: '/operation/alipay-remit/create',
    params: {
      method: 'post',
      isFormData: true,
      ...params,
    },
  });
};

export const getAlipayRemitVerifyCode = () => {
  return request({
    url: '/operation/alipay-remit/get-verify-code',
  });
};

export const authorizeAlipayWithVerifyCode = params => {
  return request({
    url: '/operation/alipay-remit/pay',
    params,
  });
};

export const getAlipayRemitList = params => {
  return request({
    url: '/operation/alipay-remit/list',
    params,
  });
};

export const cancelAlipayRemit = params => {
  return request({
    url: '/operation/alipay-remit/close',
    params,
  });
};

export const getAlipayRemitDetail = params => {
  return request({
    url: '/operation/alipay-remit/query-detail-list',
    params,
  });
};
